module.exports = __webpack_public_path__ + "img/bell2.1d7bebe7.svg";